module.exports = __webpack_public_path__ + "ad8ec445b51885d865b2d2eda8f79c2d.svg";